import { useTranslations } from '@/lib/next-shim'
import { MapPinIcon, ClockIcon, CurrencyEuroIcon } from '@heroicons/react/20/solid'
import { AvailabilityMeetingPlace } from '@/core/graphql/types'
import { getMeetingPlaceIcon, getMeetingPlaceLabel } from '../lib/helpers'
import { MeetingLink } from '../api/getMeetingLink'

type MeetingPlaceProps = {
  availabilities: MeetingLink['availabilities']
  meetingPlace: AvailabilityMeetingPlace
}

export function MeetingPlace({ availabilities, meetingPlace }: MeetingPlaceProps) {
  const t = useTranslations()
  const MeetingPlaceIcon = getMeetingPlaceIcon(meetingPlace)
  return (
    <div className="border border-gray-200 rounded-lg p-4 hover:border-primary transition-colors">
      <div className="flex items-center mb-2">
        <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary">
          <MeetingPlaceIcon className="h-5 w-5 text-primary" aria-hidden="true" />
        </div>
        <h4 className="ml-3 text-base font-medium text-gray-900">{getMeetingPlaceLabel(meetingPlace, t)}</h4>
      </div>

      {availabilities.map((availability) => (
        <div key={availability._id} className="mt-3 pl-13 text-sm">
          {availability.address && (
            <div className="flex items-start mb-1.5">
              <MapPinIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0" />
              <p className="text-gray-700">{availability.address.description}</p>
            </div>
          )}
          {availability.paymentConfig?.requiresPayment && (
            <div className="flex items-center mb-1.5">
              <CurrencyEuroIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0" />
              <p className="text-gray-900 font-medium">
                {new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: 'EUR',
                }).format(availability.paymentConfig.basePrice || 0)}
              </p>
            </div>
          )}
          {availability.avgMeetingDuration && (
            <div className="flex items-center">
              <ClockIcon className="h-5 w-5 text-gray-400 mr-2 flex-shrink-0" />
              <p className="text-gray-700">{availability.avgMeetingDuration} min</p>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
